import React from 'react';
import { View, Text, TouchableOpacity, ScrollView, Image, Platform } from 'react-native';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import styles from '../../styles/layout/AppLayoutStyles';

interface AppLayoutProps {
  children: React.ReactNode;
  title?: string;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children, title = "PMS" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isDesktop = useMediaQuery({ minWidth: 768 });

  const menuItems = [
    {
      key: 'create-project',
      icon: '➕',
      path: '/create-project',
      title: '프로젝트 생성',
    },
    {
      key: 'projectstatus',
      icon: '📊',
      path: '/projectstatus',
      title: '프로젝트 상태',
    },
    {
      key: 'cron-dashboard',
      icon: '⚙️',
      path: '/cron-dashboard',
      title: '크론잡 관리',
    },
    {
      key: 'ssl-monitoring',
      icon: '🔒',
      path: '/ssl-monitoring',
      title: 'SSL 모니터링',
    },
    {
      key: 'prometheus-monitoring',
      icon: '📊',
      path: '/prometheus-monitoring',
      title: '시스템 모니터링',
    },
    // 추후 메뉴 추가 가능
  ];

  const getSelectedKey = (pathname: string): string => {
    for (const item of menuItems) {
      if (pathname === item.path) {        return item.key;
      }
    }
    return '';
  };

  if (!isDesktop) {
    // 모바일 레이아웃 - 기존 UI 유지
    return <>{children}</>;
  }

  // PC 레이아웃 - dmsWeb 스타일
  return (
    <View style={[
      styles.container,
      Platform.OS === 'web' && { minHeight: '100vh' as any }
    ]}>
      {/* 사이드바 */}
      <View style={styles.sider}>
        <TouchableOpacity 
          style={[
            styles.logo,
            Platform.OS === 'web' && { cursor: 'pointer' as any }
          ]}
          onPress={() => navigate('/')}
        >
          <Text style={styles.logoTitle}>PMS</Text>
          <Text style={styles.logoSubtitle}>Project Management System</Text>
        </TouchableOpacity>        
        <View style={styles.menu}>
          {menuItems.map(item => (
            <TouchableOpacity
              key={item.key}
              style={[
                styles.menuItem,
                getSelectedKey(location.pathname) === item.key && styles.menuItemSelected,
                Platform.OS === 'web' && { cursor: 'pointer' as any }
              ]}
              onPress={() => navigate(item.path)}
            >
              <Text style={styles.menuIcon}>{item.icon}</Text>
              <Text style={[
                styles.menuText,
                getSelectedKey(location.pathname) === item.key && styles.menuTextSelected
              ]}>{item.title}</Text>
            </TouchableOpacity>
          ))}
        </View>
      </View>

      {/* 메인 컨텐츠 */}
      <View style={styles.layout}>
        <View style={styles.header}>
          <Text style={styles.headerTitle}>{title}</Text>
        </View>
        <ScrollView style={styles.content}>
          {children}        </ScrollView>
      </View>
    </View>
  );
};

export default AppLayout;